import React from 'react';
import { CMS_THEME } from 'src/common/enums';
import AppLinkBundle, { AppLinkBundleProps } from 'src/components/app_link_bundle/AppLinkBundle';

interface StorageAppLinkBundleProps {
  analyticsEventParams: AppLinkBundleProps['analyticsEventParams'];
  bodyClassName?: string;
  cmsTheme?: CMS_THEME;
  className?: string;
  node: IStorageAppLinkBundle;
}

const StorageAppLinkBundle: React.FC<StorageAppLinkBundleProps> = ({
  analyticsEventParams,
  bodyClassName,
  className,
  cmsTheme,
  node: appLinkBundle,
}) => {
  return (
    <AppLinkBundle
      analyticsEventParams={analyticsEventParams}
      appStoreLink={appLinkBundle.field_appstore_link}
      body={appLinkBundle.field_label}
      className={className}
      bodyClassName={bodyClassName}
      cmsTheme={cmsTheme}
      playStoreLink={appLinkBundle.field_playstore_link}
      qrCodeLink={appLinkBundle.field_qr_link}
    />
  );
};

export default StorageAppLinkBundle;
